import { render, staticRenderFns } from "./ModalCustomer.vue?vue&type=template&id=fa4d3978"
import script from "./ModalCustomer.vue?vue&type=script&lang=ts"
export * from "./ModalCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports